<template>
  <div class="content">
    <router-view/>
    <BackgroundAudioPlayer/>
    <ImageViewer />
    <HintsViewer />
    <BlockViewer />
    <Notification/>
    <ServiceWorkerUpdatePopup />
    <SubscriptionPopup/>
    <AboutSubscriptionPopup/>
    <ConfirmationPopup/>
    <GoalDonePopup/>
    <TimeZonePopup/>
  </div>
</template>

<script setup lang="ts">
import {useHead} from "@vueuse/head";
import BackgroundAudioPlayer from "@/components/UI/AudioPlayer/BackgroundAudioPlayer.vue";
import ImageViewer from "@/components/UI/ImageViewer/ImageViewer.vue";
import HintsViewer from "@/components/Home/Content/HintsViewer.vue";
import BlockViewer from "@/components/Home/Content/BlockViewer.vue";
import {Notifications} from "@kyvg/vue3-notification";
import ServiceWorkerUpdatePopup from "@/pwa/components/ServiceWorkerUpdatePopup.vue";
import SubscriptionPopup from "@/components/User/Settings/Popup/SubscriptionPopup.vue";
import ConfirmationPopup from "@/components/UI/Pupup/ConfirmationPopup.vue";
import GoalDonePopup from "@/components/Goal/Popup/GoalDonePopup.vue";
import TimeZonePopup from "@/components/User/Auth/TimeZonePopup.vue";
import Notification from "@/components/UI/Notification.vue";
import AboutSubscriptionPopup from "@/components/User/Settings/Popup/AboutSubscriptionPopup.vue";

useHead({
  title: 'Magic moon'
})
</script>

